/* runSettled.js — which messages this browser has already drawn inside a run.

   services/mediaRuns rule 5 (the phone's services/runSettled.ts is the same idea):
   ONCE GROUPED, STAYS GROUPED. Kept in localStorage, which reads synchronously —
   the chat judges a row on its first frame. Bounded per chat and in chats; a key
   that falls off only means that item is judged afresh by rules 1–3. */
import { runSettleKeys } from './mediaRuns';

const KEY = 'media_runs_settled_v1';
const PER_CHAT = 600;
const CHATS = 300;

const mem = new Map();
try {
  const obj = JSON.parse(window.localStorage.getItem(KEY) || 'null');
  if (obj && typeof obj === 'object') {
    for (const [chatId, keys] of Object.entries(obj)) if (Array.isArray(keys)) mem.set(chatId, new Set(keys.map(String)));
  }
} catch { /* private window / blocked storage — rules 1–3 decide */ }

let timer = null;
function persistSoon() {
  if (timer) return;
  timer = setTimeout(() => {
    timer = null;
    try {
      const out = {};
      for (const c of Array.from(mem.keys()).slice(-CHATS)) out[c] = Array.from(mem.get(c) || []).slice(-PER_CHAT);
      window.localStorage.setItem(KEY, JSON.stringify(out));
    } catch { /* full or blocked — tried again on the next run drawn */ }
  }, 800);
}

export function settledFor(chatId) {
  const id = String(chatId || '');
  let s = mem.get(id);
  if (!s) { s = new Set(); mem.set(id, s); }
  return s;
}

export function settleRuns(chatId, rows) {
  if (!chatId) return;
  const s = settledFor(chatId);
  let added = false;
  for (const k of runSettleKeys(rows)) if (!s.has(k)) { s.add(k); added = true; }
  if (added) { mem.delete(String(chatId)); mem.set(String(chatId), s); persistSoon(); notifySoon(chatId); }
}

/* the chat list re-reads a row whose run memory grew — told after the chat's render */
const listeners = new Set();
const pendingNotify = new Set();
export function onRunsSettled(cb) { listeners.add(cb); return () => { listeners.delete(cb); }; }
function notifySoon(chatId) {
  pendingNotify.add(String(chatId));
  setTimeout(() => {
    const ids = Array.from(pendingNotify); pendingNotify.clear();
    for (const id of ids) for (const cb of Array.from(listeners)) { try { cb(id); } catch { /* one row */ } }
  }, 0);
}
